export const config = {
  api: {
    endpoints: {
      pricing: "/api/pricing",
    },
  },
  lenderPrice: {
    companyId: process.env.LENDER_PRICE_COMPANY_ID,
    api: {
      // baseUrl: "https://uat-rapi.lenderprice.com",
      baseUrl: "https://ppe-rapi.lenderprice.com",
      secretEndpoint: "/encodeAES128",
      pricingEndpoint: "/rest/pricing/multisearch",
    },
  },
} as const;
